import BackgroudImage from "../assets/images/bg/choose-us-bg3.jpg";
import AppCard from "./AppCard"
import IndustryBanner from "./IndustryBanner";
import { useTranslation } from 'react-i18next';

const IndustryApps = () =>  {
  const { t } = useTranslation();
  return (

    <div className="flex-col" style={{ backgroundImage: `url(${BackgroudImage})` }}>

      <div> <IndustryBanner></IndustryBanner> </div>
      
      <div className="flex p-8 gap-8">
            <AppCard title={t("predictive_maintenance")} description={t("predictive_maintenance_description")} link="PredictiveMaintenance"></AppCard>
            <AppCard title={t("root_cause_analysis")} description={t("root_cause_analysis_description")} link="RootCauseAnalysis"></AppCard>
            <AppCard title={t("production_time_prediction")} description={t("production_time_prediction_description")} link="ProductionTimePrediction"></AppCard>
      </div>
      <div className="flex p-8 gap-8">
            <AppCard title={t("anomaly_detection")} description={t("anomaly_detection_description")} link="AnomalyDetection"></AppCard>
            <AppCard title={t("energy_production_forecasting")} description={t("energy_production_forecasting_description")} link="EnergyProductionForecasting"></AppCard>
            <AppCard title={t("energy_consumption_forecasting")} description={t("energy_consumption_forecasting_description")} link="EnergyConsumptionForecasting"></AppCard>
      </div>

    </div>
    
  );
}
export default IndustryApps;
